import { render, staticRenderFns } from "./TinyMCE.vue?vue&type=template&id=6641e68a"
import script from "./TinyMCE.vue?vue&type=script&lang=js"
export * from "./TinyMCE.vue?vue&type=script&lang=js"
import style0 from "./TinyMCE.vue?vue&type=style&index=0&id=6641e68a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports